import { useTranslation } from '@aimsos/i18n';

import ConfirmActionModal from './ConfirmActionModal';

/**
 * Confirm before deleting a removed user for good (permanent).
 *
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {string} props.name
 * @param {() => void} props.onClose
 * @param {() => Promise<boolean>} props.onConfirm
 */
function DeleteUserConfirmModal({ isOpen, name, onClose, onConfirm }) {
  const { t } = useTranslation('people-access');
  return (
    <ConfirmActionModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title={t('memberDetail.confirm.deleteUser.title', { name })}
      message={t('memberDetail.confirm.deleteUser.message')}
      confirmLabel={t('memberDetail.confirm.deleteUser.confirm')}
      confirmVariant="danger"
    />
  );
}

export default DeleteUserConfirmModal;
